import { baseServiceExportExcel } from './baseServiceExportExcel'
import {
  showErrorToast,
  showSuccessToast,
  showLoadingToast,
  toastKey,
} from '../utils/showToast'
class ExportExcelBookListBorrow extends baseServiceExportExcel {
  async getAll() {
    try {
      showLoadingToast(
        'Đang tải về...',
        toastKey.BOOKS_MANAGEMENT.BORROW.LIST.EXPORT
      )
      const res = await this.get('borrow/export')
      if (!res.ok)
        showErrorToast(
          'Xuất excel thất bại!',
          toastKey.BOOKS_MANAGEMENT.BORROW.LIST.EXPORT
        )
      showSuccessToast(
        'Xuất excel thành công!',
        toastKey.BOOKS_MANAGEMENT.BORROW.LIST.EXPORT
      )
      return res
    } catch (error) {
      showErrorToast({
        error: error,
        message: 'Không tải được file excel!',
        toastId: toastKey.BOOKS_MANAGEMENT.BORROW.LIST.EXPORT,
      })
    }
  }
}

export const exportExcelBookListBorrow = new ExportExcelBookListBorrow()
